import { render, staticRenderFns } from "./AdvancedTxPlannedV2.vue?vue&type=template&id=71b5ea34&scoped=true"
import script from "./AdvancedTxPlannedV2.vue?vue&type=script&lang=js"
export * from "./AdvancedTxPlannedV2.vue?vue&type=script&lang=js"
import style0 from "./AdvancedTxPlannedV2.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./AdvancedTxPlannedV2.vue?vue&type=style&index=1&id=71b5ea34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5ea34",
  null
  
)

export default component.exports